import { FieldValues, Path, PathValue } from 'react-hook-form';
import {
  ALLOWED_TO_SKIP_TIMEOUT_DEFAULT_VALUE,
  START_TIME_REMAINING_EQUIPEMENTS_DEFAULT_VALUE,
  UNDETECTED_EQUIPEMENTS_TIMEOUT_AT_START_DEFAULT_VALUE,
} from '@/schemas/check-point/check-point.schema';

interface SetCheckPointRequiredFieldsProps<TSchema extends FieldValues> {
  setValue: (
    name: Path<TSchema>,
    value: PathValue<TSchema, Path<TSchema>>
  ) => void;
  data: TSchema;
  translatedItem?: TSchema;
}

export const setCheckPointRequiredFields = <TSchema extends FieldValues>({
  setValue,
  data,
  translatedItem,
}: SetCheckPointRequiredFieldsProps<TSchema>) => {
  setValue('reportIcon' as Path<TSchema>, data.reportIcon ?? '');
  setValue('appIcon' as Path<TSchema>, data.appIcon ?? '');
  setValue('name' as Path<TSchema>, (translatedItem?.name || data.name) ?? '');
  setValue('type' as Path<TSchema>, data.type ?? '');
  // Set from stored data on every tab, so the schema default never overwrites a stored value
  setValue(
    'allowedToSkipTimeout' as Path<TSchema>,
    data.allowedToSkipTimeout ?? ALLOWED_TO_SKIP_TIMEOUT_DEFAULT_VALUE
  );
  setValue(
    'startTimeRemainingEquipements' as Path<TSchema>,
    data.startTimeRemainingEquipements ??
      START_TIME_REMAINING_EQUIPEMENTS_DEFAULT_VALUE
  );
  setValue(
    'undetectedEquipementsTimeoutAtStart' as Path<TSchema>,
    data.undetectedEquipementsTimeoutAtStart ??
      UNDETECTED_EQUIPEMENTS_TIMEOUT_AT_START_DEFAULT_VALUE
  );
};
